const setSelectedCalendarViewhandler = ({
    dispatch,
    setSelectedCalendarViewRedux,
    setFilters,
    getCardData,
    getListData,
    calendarView,
    userFilters,
    visibleDateRange,
    selectedDate,
    getPreviousDate,
    convertDateToISOString,
    addDaysToDate,
    isStartDateLessThanEndDate,
    setViewDataEmpty,
    getViewData,
    getRefinedFilters,
    view
}) => {
    let endDate, startDate;

    // Defensive guard: if the persisted userFilters has a reversed
    // (endDate < startDate) range, sanitize it before dispatching list/card
    // fetches so the API doesn't receive an invalid window.
    let sanitizedUserFilters = userFilters;
    if (
        userFilters?.startDate &&
        userFilters?.endDate &&
        !isStartDateLessThanEndDate(
            userFilters.startDate,
            userFilters.endDate
        )
    ) {
        sanitizedUserFilters = {
            ...userFilters,
            startDate: userFilters.endDate,
            endDate: userFilters.startDate,
        };
        dispatch(
            setFilters({
                startDate: sanitizedUserFilters.startDate,
                endDate: sanitizedUserFilters.endDate,
            })
        );
    }

    dispatch(setSelectedCalendarViewRedux(view));
    dispatch(
        setFilters({
            filterParam: view.id,
        })
    );
    if (calendarView === 'Month' || calendarView === 'Week') {
        dispatch(
            getCardData({
                ...sanitizedUserFilters,
                filterParam: view.id,
            })
        );
    } else if (calendarView === 'List') {
        dispatch(
            getListData({
                ...sanitizedUserFilters,
                filterParam: view.id,
            })
        );
    }

    if (
        !(
            visibleDateRange[0]?.getTime() <=
                new Date().setHours(0, 0, 0, 0) &&
            visibleDateRange[1]?.getTime() >=
                new Date().setHours(0, 0, 0, 0)
        ) &&
        new Date(selectedDate).getTime() <= new Date().setHours(0, 0, 0, 0)
    ) {
        let firstDateOfMonthOneYearFromToday = new Date(
            getPreviousDate(selectedDate, 365).getFullYear(),
            getPreviousDate(selectedDate, 365).getMonth(),
            1
        );
        let endDateOfNextMonth = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() + 2,
            0
        );
        let firstDateOfPreviousMonth = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() - 1,
            1
        );
        dispatch(setViewDataEmpty());
        if (
            firstDateOfPreviousMonth.getTime() >=
                firstDateOfMonthOneYearFromToday.getTime() &&
            endDateOfNextMonth.getTime() <= firstDateOfMonthOneYearFromToday
        ) {
            startDate = convertDateToISOString(
                firstDateOfMonthOneYearFromToday,
                'start'
            );
            endDate = convertDateToISOString(
                addDaysToDate(firstDateOfMonthOneYearFromToday, 90),
                'end'
            );
            isStartDateLessThanEndDate(startDate, endDate) &&
                dispatch(
                    getViewData({
                        ...userFilters,
                        filterParam: view.id,
                        startDate: startDate,
                        endDate: endDate,
                        sortOrder: 'ASC',
                        sortParam: 'surgeryStartDate',
                    })
                );

            startDate = convertDateToISOString(
                addDaysToDate(firstDateOfMonthOneYearFromToday, 90),
                'start'
            );
            endDate = convertDateToISOString(new Date(), 'end');
            isStartDateLessThanEndDate(startDate, endDate) &&
                dispatch(
                    getViewData({
                        ...userFilters,
                        filterParam: view.id,
                        startDate: startDate,
                        endDate: endDate,
                        sortOrder: 'ASC',
                        sortParam: 'surgeryStartDate',
                    })
                );
        } else {
            startDate = convertDateToISOString(
                firstDateOfPreviousMonth,
                'start'
            );
            endDate = convertDateToISOString(endDateOfNextMonth, 'end');
            isStartDateLessThanEndDate(startDate, endDate) &&
                dispatch(
                    getViewData({
                        ...userFilters,
                        filterParam: view.id,
                        startDate: startDate,
                        endDate: endDate,
                        sortOrder: 'ASC',
                        sortParam: 'surgeryStartDate',
                    })
                );
            startDate = convertDateToISOString(endDateOfNextMonth, 'start');
            endDate = convertDateToISOString(new Date(), 'end');
            isStartDateLessThanEndDate(startDate, endDate) &&
                dispatch(
                    getViewData({
                        ...userFilters,
                        filterParam: view.id,
                        startDate: startDate,
                        endDate: endDate,
                        sortOrder: 'ASC',
                        sortParam: 'surgeryStartDate',
                    })
                );

            startDate = convertDateToISOString(
                getPreviousDate(new Date(), 365),
                'start'
            );
            endDate = convertDateToISOString(
                firstDateOfPreviousMonth,
                'end'
            );
            isStartDateLessThanEndDate(startDate, endDate) &&
                dispatch(
                    getViewData({
                        ...userFilters,
                        filterParam: view.id,
                        startDate: startDate,
                        endDate: endDate,
                        sortOrder: 'ASC',
                        sortParam: 'surgeryStartDate',
                    })
                );
        }
    } else if (
        !(
            visibleDateRange[0]?.getTime() <=
                new Date().setHours(0, 0, 0, 0) &&
            visibleDateRange[1]?.getTime() >=
                new Date().setHours(0, 0, 0, 0)
        ) &&
        new Date(selectedDate).getTime() >= new Date().setHours(0, 0, 0, 0)
    ) {
        let currentMonthEndDate = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() + 1,
            0
        );
        startDate = convertDateToISOString(
            getPreviousDate(currentMonthEndDate, 364),
            'start'
        );
        endDate = convertDateToISOString(currentMonthEndDate, 'end');

        dispatch(setViewDataEmpty());
        isStartDateLessThanEndDate(startDate, endDate) &&
            dispatch(
                getViewData({
                    ...userFilters,
                    filterParam: view.id,
                    startDate: startDate,
                    endDate: endDate,
                    sortOrder: 'ASC',
                    sortParam: 'surgeryStartDate',
                })
            );
    } else {
        let endDateOfNextMonth = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() + 2,
            0
        );
        let firstDateOfPreviousMonth = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() - 1,
            1
        );
        startDate = convertDateToISOString(
            firstDateOfPreviousMonth,
            'start'
        );
        endDate = convertDateToISOString(endDateOfNextMonth, 'end');

        dispatch(setViewDataEmpty());
        isStartDateLessThanEndDate(startDate, endDate) &&
            dispatch(
                getViewData({
                    ...userFilters,
                    filterParam: view.id,
                    startDate: startDate,
                    endDate: endDate,
                    sortOrder: 'ASC',
                    sortParam: 'surgeryStartDate',
                })
            );
        startDate = convertDateToISOString(
            getPreviousDate(new Date(), 365),
            'start'
        );
        endDate = convertDateToISOString(firstDateOfPreviousMonth, 'end');
        isStartDateLessThanEndDate(startDate, endDate) &&
            dispatch(
                getViewData({
                    ...userFilters,
                    filterParam: view.id,
                    startDate: startDate,
                    endDate: endDate,
                    sortOrder: 'ASC',
                    sortParam: 'surgeryStartDate',
                })
            );
    }

    dispatch(
        getRefinedFilters({
            filterParam: view.id,
        })
    );
};

export default setSelectedCalendarViewhandler;